import React from 'react';
import { TextField, InputAdornment, TextFieldProps } from '@mui/material';

interface InputTextProps {
  InputPropsClasses?: object;
  icon?: any;
  positionIcon?: 'end' | 'start';
  field?: any;
}

type IInputTextProps = React.InputHTMLAttributes<unknown> &
  TextFieldProps &
  InputTextProps;

const KogInputTextLogin = React.forwardRef(
  (
    { positionIcon, title, field, ...props }: IInputTextProps,
    ref: any,
  ) => {
    return (
      <TextField
        {...field}
        fullWidth
        ref={ref}
        size="small"
        InputProps={{
          [positionIcon === 'start'
            ? 'startAdornment'
            : 'endAdornment']: props.icon ? (
              <InputAdornment position={positionIcon || 'start'}>
                {props.icon}
              </InputAdornment>
            ) : null,
          classes: props.InputPropsClasses,
          autoComplete: 'new-password',
          title
        }}
        {...props}
      />
    );
  }
);

export default KogInputTextLogin;
